module.exports = __webpack_public_path__ + "media/photo/AdobeStock_183348776_Edit_Wide-b10435db.jpg";